import { lazy } from 'react';

/**
 * Creates a lazily loaded component
 * @param {Function} importFunc - Dynamic import function for the component
 * @returns {React.LazyExoticComponent} Lazy loaded component
 */
export const lazyLoad = (importFunc) => {
  return lazy(importFunc);
};
